import React, { useRef } from "react";
import { motion } from "framer-motion";

/*
 * MagneticButton — subtle magnetic pull toward cursor for a premium feel.
 * Falls back to standard click area on touch.
 */
export default function MagneticButton({ children, className = "", strength = 18, ...rest }) {
  const ref = useRef(null);
  const innerRef = useRef(null);

  const onMove = (e) => {
    const el = ref.current; const inner = innerRef.current;
    if (!el || !inner) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    inner.style.transform = `translate(${(x / rect.width) * strength}px, ${(y / rect.height) * strength}px)`;
  };
  const onLeave = () => {
    const inner = innerRef.current;
    if (inner) inner.style.transform = "translate(0,0)";
  };

  return (
    <motion.a
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={className}
      {...rest}
    >
      <span
        ref={innerRef}
        style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem", transition: "transform 0.25s ease-out" }}
      >
        {children}
      </span>
    </motion.a>
  );
}
